import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/lib/locale/es';
import '@/assets/global.css';

import store from '@stores';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: store.getters['persist/layout/isDark'],
    themes: {
      light: {
        primary: '#223e85',
        secondary: '#424242',
        accent: '#a27200',
        error: '#aa3434',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: '#00207c',
        secondary: '#424242',
        accent: '#FAB81B',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
});
